define('viewmodels/secured/explorer/details/tabs/actions/ActionProvider',[
    'viewmodels/secured/explorer/details/tabs/actions/ShareAction',
    'viewmodels/secured/explorer/details/tabs/actions/EmailAsLinkAction',
    'viewmodels/secured/explorer/details/tabs/actions/EmailAsAttachmentAction',
    'viewmodels/secured/explorer/details/tabs/actions/EmailAsShareAction',
    'viewmodels/secured/explorer/details/tabs/actions/DocumentLinksAction',
    'viewmodels/secured/explorer/details/tabs/actions/SaveNewVersionAction',    
    'viewmodels/secured/explorer/details/tabs/actions/CopyDocumentsAction',
    'viewmodels/secured/explorer/details/tabs/actions/MoveDocumentsAction',
    'viewmodels/secured/explorer/details/tabs/actions/BulkDownloadAction',
    'viewmodels/secured/explorer/details/tabs/actions/ExportDocumentsAction',
    'viewmodels/secured/explorer/details/tabs/actions/ReplaceFileAction',
    'viewmodels/secured/explorer/details/tabs/actions/ModifyFieldAction',

    'viewmodels/secured/explorer/details/tabs/actions/CheckoutAction',
    'viewmodels/secured/explorer/details/tabs/actions/CheckinAction',
    'viewmodels/secured/explorer/details/tabs/actions/CancelCheckoutAction',

    'viewmodels/secured/explorer/details/tabs/actions/DeleteAction',
    'viewmodels/secured/explorer/details/tabs/actions/UndeleteAction',
    'viewmodels/secured/explorer/details/tabs/actions/PurgeDeletedAction'
],
function (
    ShareAction,
    EmailAsLinkAction,
    EmailAsAttachmentAction,
    EmailAsShareAction,
    DocumentLinksAction,
    SaveNewVersionAction,
    CopyDocumentsAction,
    MoveDocumentsAction,
    BulkDownloadAction,
    ExportDocumentsAction,
    ReplaceFileAction,
    ModifyFieldAction,

    CheckoutAction,
    CheckinAction,
    CancelCheckoutAction,

    DeleteAction,
    UndeleteAction,
    PurgeDeletedAction
){

    function ActionProvider(context) {
        this.context = context;
    }

    ActionProvider.prototype = (function () {

        return {
            ShareAction: wrapper(ShareAction),
            EmailAsLinkAction: wrapper(EmailAsLinkAction),
            EmailAsAttachmentAction: wrapper(EmailAsAttachmentAction),
            EmailAsShareAction: wrapper(EmailAsShareAction),
            DocumentLinksAction: wrapper(DocumentLinksAction),
            SaveNewVersionAction: wrapper(SaveNewVersionAction),
            CopyDocumentsAction: wrapper(CopyDocumentsAction),
            MoveDocumentsAction: wrapper(MoveDocumentsAction),
            BulkDownloadAction: wrapper(BulkDownloadAction),
            ExportDocumentsAction: wrapper(ExportDocumentsAction),
            ReplaceFileAction: wrapper(ReplaceFileAction),
            ModifyFieldAction: wrapper(ModifyFieldAction),

            CheckoutAction: wrapper(CheckoutAction),
            CheckinAction: wrapper(CheckinAction),
            CancelCheckoutAction: wrapper(CancelCheckoutAction),

            DeleteAction: wrapper(DeleteAction),
            UndeleteAction: wrapper(UndeleteAction),
            PurgeDeletedAction: wrapper(PurgeDeletedAction)
        };
    }());

    function wrapper(Action) {
        return function (disableFilters, hideFilters) {
            return new Action(this.context, disableFilters, hideFilters);
        };
    }

    return ActionProvider;
});
